import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.html',
  styleUrls: ['./confirmation-dialog.css']
})
export class ConfirmationDialogComponent implements OnInit {
  @Output() yesEvent = new EventEmitter<string>();

  localFormGroup: FormGroup;

  confirmationMessage: string;
  confirmationMessageTitle: string;
  confirmationYES: 'Confirmations.Yes';
  confirmationNO: 'Confirmations.No';
  hasFreeText: boolean;
  freeTextLabel: string;
  htmlContent: string;
  isCustomized: false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    dialogRef.disableClose = true;
  }


  ngOnInit(): void {
    if (this.data.confirmationMessage) {
      this.confirmationMessage = this.data.confirmationMessage;
      this.confirmationMessageTitle = this.data.confirmationMessageTitle || '';
      if (this.data.optionalButtons) {
        this.confirmationYES = this.data.optionalButtons.confirmationYES;
        this.confirmationNO = this.data.optionalButtons.confirmationNO;
      }
    } else {
      this.htmlContent = this.data?.htmlContent || this.data?.title || this.data;
    }
    this.hasFreeText = this.data.hasFreeText;
    this.freeTextLabel = this.data.freeTextLabel;
    this.localFormGroup = this.fb.group({
      additionalInfo: new FormControl()
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.yesEvent.next(this.localFormGroup.get('additionalInfo').value);
  }
}
